<template>
  <div class="comm-root">
    <header class="comm-header">
      <h2>Comunicação Ativa</h2>
      <p>
        Mantemos a comunicação sempre ativa em nossos bate-papos para garantir
        alinhamento e clareza.
      </p>
      <p class="comm-quote">
        “Uma imagem vale mais que 10 mil palavras” um vídeo vale mais que 10 mil
        imagens.
      </p>
    </header>

    <section class="comm-card">
      <!-- Header Card -->
      <div class="comm-card-header">
        <div class="left">
          <span class="title">Simulação de Cultura</span>
          <span class="subtitle">
            {{
              chatTab === 'internal' ? 'Bate-papo Interno' : 'Bate-papo Externo'
            }}
          </span>
        </div>
      </div>

      <!-- Tabs -->
      <div class="comm-tabs">
        <button
          type="button"
          :class="[
            'comm-tab',
            { 'comm-tab--active-internal': chatTab === 'internal' },
          ]"
          @click="chatTab = 'internal'"
        >
          Bate-papo Interno
        </button>
        <button
          type="button"
          :class="[
            'comm-tab',
            { 'comm-tab--active-external': chatTab === 'external' },
          ]"
          @click="chatTab = 'external'"
        >
          Bate-papo Externo
        </button>
      </div>

      <!-- Conteúdo -->
      <div class="comm-body">
        <!-- Interno -->
        <div v-if="chatTab === 'internal'" class="chat-list">
          <!-- João (Eu) -->
          <div class="chat-row">
            <div class="avatar avatar--blue">
              <img :src="avatars.joao" alt="João Silva" loading="lazy" />
            </div>
            <div class="bubble bubble--left">
              <div class="bubble-author">João Silva</div>
              <div class="bubble-text">
                Recebi o feedback sobre esta tarefa. Obrigado pelos
                apontamentos!
              </div>
            </div>
          </div>

          <!-- eSUS Feedback -->
          <div class="chat-row chat-row--reverse">
            <div class="avatar avatar--cyan">
              <img
                :src="avatars.equipe"
                alt="Equipe eSUS Feedback"
                loading="lazy"
              />
            </div>
            <div class="bubble bubble--right bubble--blue">
              <div class="bubble-author bubble-author--right">
                eSUS Feedback
              </div>
              <div class="bubble-text bubble-text--strong">
                Excelente! Lembre-se: encaramos isso como oportunidade de
                aprendizagem. Foco na solução para o próximo feedback. 🚀
              </div>
            </div>
          </div>

          <!-- João -->
          <div class="chat-row">
            <div class="avatar avatar--blue">
              <img :src="avatars.joao" alt="João Silva" loading="lazy" />
            </div>
            <div class="bubble bubble--left">
              <div class="bubble-author">João Silva</div>
              <div class="bubble-text">
                Com certeza. Já identifiquei onde melhorar. Somos eternos
                estudantes! 📚
              </div>
            </div>
          </div>
        </div>

        <!-- Externo -->
        <div v-else class="chat-list">
          <!-- Maria (Profissional Saúde) -->
          <div class="chat-row">
            <div class="avatar avatar--green">
              <img :src="avatars.maria" alt="Maria Oliveira" loading="lazy" />
            </div>
            <div class="bubble bubble--left">
              <div class="bubble-author">Maria Oliveira</div>
              <div class="bubble-text">
                Estou com dificuldade de entender o denominador do indicador de
                gestantes e puérperas. Os números não estão batendo com minha
                realidade.
              </div>
            </div>
          </div>

          <!-- João -->
          <div class="chat-row chat-row--reverse">
            <div class="avatar avatar--blue">
              <img :src="avatars.joao" alt="João Silva" loading="lazy" />
            </div>
            <div class="bubble bubble--right bubble--blue">
              <div class="bubble-author bubble-author--right">João Silva</div>
              <div class="bubble-text bubble-text--strong">
                Olá! Compreendo sua dúvida. Às vezes os filtros de período podem
                causar essa diferença. Vamos verificar juntos passo a passo?
              </div>
            </div>
          </div>

          <!-- Maria -->
          <div class="chat-row">
            <div class="avatar avatar--green">
              <img :src="avatars.maria" alt="Maria Oliveira" loading="lazy" />
            </div>
            <div class="bubble bubble--left">
              <div class="bubble-author">Maria Oliveira</div>
              <div class="bubble-text">
                Ah, verdade! Eu estava olhando o mês errado no filtro do
                sistema. Agora bateu. Obrigado pela paciência!
              </div>
            </div>
          </div>

          <!-- João -->
          <div class="chat-row chat-row--reverse">
            <div class="avatar avatar--blue">
              <img :src="avatars.joao" alt="João Silva" loading="lazy" />
            </div>
            <div class="bubble bubble--right bubble--blue">
              <div class="bubble-author bubble-author--right">João Silva</div>
              <div class="bubble-text bubble-text--strong">
                Imagina! Estamos aqui para apoiar. O monitoramento correto é
                essencial para nós. Conte comigo! 🤝
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Rodapé dinâmico -->
      <footer class="comm-footer">
        <p v-if="chatTab === 'internal'">
          "Respondemos com clareza e foco em soluções."
        </p>
        <p v-else>
          "Mantemos a comunicação com gentileza, paciência e coragem."
        </p>
      </footer>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CulturaCommunication',
  data() {
    return {
      chatTab: 'internal',
      avatars: {
        joao: 'https://i.pravatar.cc/150?img=59',
        maria: 'https://i.pravatar.cc/150?img=16',
        equipe:
          'https://api.dicebear.com/7.x/thumbs/svg?seed=EquipeEsusFeedback',
      },
    }
  },
}
</script>

<style scoped>
.comm-root {
  margin: 0 auto;
}

.comm-header {
  text-align: center;
  margin-bottom: 16px;
}

.comm-header h2 {
  font-size: 26px;
  font-weight: 700;
  color: #0f172a;
}

.comm-header p {
  font-size: 14px;
  color: #64748b;
  margin-top: 6px;
}

.comm-quote {
  font-style: italic;
  margin-top: 6px;
  color: #475569;
}

/* CARD */

.comm-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.03);
}

.comm-card-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.comm-card-header .title {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.comm-card-header .subtitle {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #94a3b8;
}

/* TABS */

.comm-tabs {
  display: flex;
  font-size: 13px;
  font-weight: 600;
}

.comm-tab {
  flex: 1;
  padding: 10px 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: #64748b;
  transition: 0.2s;
}

.comm-tab--active-internal {
  background: #eff6ff;
  color: #2563eb;
  border-bottom-color: #2563eb;
}

.comm-tab--active-external {
  background: #ecfdf3;
  color: #16a34a;
  border-bottom-color: #16a34a;
}

/* BODY / CHAT */

.comm-body {
  padding: 16px;
  min-height: 260px;
}

.chat-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.chat-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.chat-row--reverse {
  flex-direction: row-reverse;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  overflow: hidden;
}

/* imagens dentro do avatar */
.avatar img {
  width: 100%;
  height: 100%;
  border-radius: 999px;
  object-fit: cover;
}

.avatar--blue {
  background: #dbeafe;
  color: #2563eb;
}

.avatar--cyan {
  background: #cffafe;
  color: #0891b2;
}

.avatar--green {
  background: #dcfce7;
  color: #16a34a;
}

.bubble {
  max-width: 80%;
  border-radius: 12px;
  padding: 8px 10px;
  font-size: 13px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.bubble--left {
  border-top-left-radius: 4px;
}

.bubble--right {
  border-top-right-radius: 4px;
}

.bubble--blue {
  background: #eff6ff;
  border-color: #bfdbfe;
}

.bubble-author {
  font-weight: 600;
  font-size: 12px;
  color: #0f172a;
  margin-bottom: 4px;
}

.bubble-author--right {
  text-align: right;
}

.bubble-text {
  color: #475569;
}

.bubble-text--strong {
  color: #1e293b;
}

/* FOOTER */

.comm-footer {
  padding: 10px 16px 12px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  text-align: center;
  font-size: 12px;
  color: #64748b;
  font-style: italic;
}
</style>
